import { mapGetters, mapState, mapActions } from 'vuex';
import FilterCategories from '../../../../../components/categories/index.vue';
import vSelect from 'vue-select';

const FILTER_KEYS = [
    'supplier',
    'brand',
    'select_category',
    'product_status',
    'product_group',
    'product_type',
    'sku',
    'store'
];

const DEFAULT_LABELS = {
    supplier: 'Proveedor',
    brand: 'Marca',
    select_category: 'Categorías',
    product_status: 'Estado de producto',
    product_group: 'Grupo de productos',
    product_type: 'Tipo de producto',
    sku: 'SKU',
    store: 'Lista de precios'
};

export default {
    components: {
        FilterCategories,
        vSelect,
    },
    data() {
        return {
            FILTER_KEYS,
            DEFAULT_LABELS,
            localFilters: {
                supplier: '',
                brand: '',
                select_category: null,
                product_status: '',
                product_group: '',
                product_type: '',
                sku: '',
                store: '',
            },
            selectedSkus: [],
            skuInput: '',
            proveedores: [],
            marcas: [],
            groups: [],
            filtros: [],
            categoryproducts: [],
            clusters: [],
        };
    },
    computed: {
        ...mapGetters(['authentication_user']),
        ...mapState({
            filters: state => state.filters.filters
        }),
        categoryName() {
            const categoryId = this.localFilters.select_category;
            if (!categoryId) return '';
            const category = this.categoryproducts.find(c => c.id === categoryId);
            return category ? category.name : '';
        },
        activeFilters() {
            const result = [];
            
            FILTER_KEYS.forEach(key => {
                if (key === 'sku') {
                    if (this.selectedSkus.length > 0) {
                        result.push({
                            key: 'sku',
                            label: this.getFilterLabel('sku'),
                            value: this.selectedSkus.join(', ')
                        });
                    }
                } else if (key === 'store') {
                    const val = this.localFilters[key];
                    if (val !== null && val !== undefined && val !== '') {
                        result.push({
                            key: 'store',
                            label: this.getFilterLabel('store'),
                            value: String(val)
                        });
                    }
                } else {
                    const val = this.localFilters[key];
                    if (val !== null && val !== undefined && val !== '' && val !== 0) {
                        result.push({
                            key,
                            label: this.getFilterLabel(key),
                            value: this.formatFilterValue(key, val)
                        });
                    }
                }
            });
            
            return result;
        },
    },
    watch: {
        filters: {
            handler() {
                this.syncLocalFilters();
            },
            immediate: true,
        },
    },
    created() {
        this.loadCategories();
        this.getFilterProveedor();
        this.getFilterMarca();
        this.getFilterOther();
        this.getFilterGroup();
        this.getFilterCluster();
    },
    methods: {
        ...mapActions(['get']),
        syncLocalFilters() {
            FILTER_KEYS.forEach(key => {
                if (Object.prototype.hasOwnProperty.call(this.filters, key)) {
                    this.localFilters[key] = this.filters[key];
                }
            });
            if (this.localFilters.sku) {
                this.selectedSkus = this.localFilters.sku.split(',').map(s => s.trim()).filter(s => s);
            }
            if (this.filters.cluster) {
                this.localFilters.store = this.filters.cluster;
            }
        },
        getCategory(row) {
            this.localFilters.select_category = row.category;
        },
        getFilterLabel(key) {
            const clientFilters = this.authentication_user?.client_filters?.filters;
            if (!clientFilters || !Array.isArray(clientFilters) || clientFilters.length === 0) {
                return DEFAULT_LABELS[key] || key;
            }
            const filter = clientFilters.find(f => f && f.key === key);
            return filter?.label || DEFAULT_LABELS[key] || key;
        },
        formatFilterValue(key, value) {
            if (key === 'select_category') {
                return this.categoryName || String(value);
            }
            return String(value);
        },
        shouldShowFilter(key) {
            const clientFilters = this.authentication_user?.client_filters?.filters;
            if (!clientFilters || !Array.isArray(clientFilters) || clientFilters.length === 0) {
                return true;
            }
            const filter = clientFilters.find(f => f && f.key === key);
            return filter?.show !== false;
        },
        getDefaultLabel(key) {
            return DEFAULT_LABELS[key] || key;
        },
        onClearSelect(filterName, val) {
            if (!val) {
                switch (filterName) {
                    case 'product_group':
                        this.localFilters.product_group = '';
                        break;
                    case 'supplier':
                        this.localFilters.supplier = '';
                        break;
                    case 'brand':
                        this.localFilters.brand = '';
                        break;
                    case 'product_type':
                        this.localFilters.product_type = '';
                        break;
                    case 'store':
                        this.localFilters.store = '';
                        break;
                    default:
                        break;
                }
            }
        },
        loadCategories() {
            this.get({
                url: `/api/categoryproducts/?page_size=5000`
            }).then((response) => {
                this.categoryproducts = response.results || [];
            });
        },
        getFilterProveedor() {
            let url = `/api/products/get_filter_marca/?filter_name=prop_extra_1`;
            if (!this.authentication_user.client_channel) {
                url += `&business=${this.authentication_user.client_business_select}`;
            }
            this.get({ url }).then((response) => {
                this.proveedores = response.results;
            });
        },
        getFilterMarca() {
            let url = `/api/products/get_filter_marca/?filter_name=prop_extra_5`;
            if (!this.authentication_user.client_channel) {
                url += `&business=${this.authentication_user.client_business_select}`;
            }
            this.get({ url }).then((response) => {
                this.marcas = response.results;
            });
        },
        getFilterGroup() {
            let url = `/api/products/get_filter_marca/?filter_name=prop_extra_4`;
            if (!this.authentication_user.client_channel) {
                url += `&business=${this.authentication_user.client_business_select}`;
            }
            this.get({ url }).then((response) => {
                this.groups = response.results;
            });
        },
        getFilterOther() {
            let url = `/api/products/get_filter_marca/?filter_name=prop_extra_2`;
            if (!this.authentication_user.client_channel) {
                url += `&business=${this.authentication_user.client_business_select}`;
            }
            this.get({ url }).then((response) => {
                this.filtros = response.results;
            });
        },
        getFilterCluster(){
            this.get({
                url: `/api/stores/?page_size=100`
            }).then((response) => {
                this.clusters = response.results
            })
        },
        parseSkuInput(value) {
            const trimmedValue = value.trim();
            const allowSpaces = this.authentication_user?.client_sku_allow_spaces;
            const separatorPattern = allowSpaces ? /[,\n\r]+/ : /[\s,]+/;
            return trimmedValue
                .split(separatorPattern)
                .map((sku) => sku.trim())
                .filter((sku) => sku !== '');
        },
        addSkuTag() {
            if (this.skuInput.trim() !== '') {
                const skus = this.parseSkuInput(this.skuInput);
                let added = false;
                skus.forEach((sku) => {
                    if (!this.selectedSkus.includes(sku)) {
                        this.selectedSkus.push(sku);
                        added = true;
                    }
                });
                if (added) {
                    this.skuInput = '';
                    this.localFilters.sku = this.selectedSkus.join(',');
                }
            }
        },
        removeSkuTag(index) {
            this.selectedSkus.splice(index, 1);
            this.localFilters.sku = this.selectedSkus.join(',');
        },
        clearSkus() {
            this.skuInput = '';
            this.selectedSkus = [];
            this.localFilters.sku = '';
        },
    }
};
